import axios from "axios";
import {ordersServicesPath} from "../../../../Constants";
import {isOrderWithCompositionReady} from "../../../../utils/compositionMediaUtils";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const ORDER_WITH_COMPOSITION_RETRY_DELAY_MS = 1500;

const orderRestUrl = ordersServicesPath + '/customers/orders'

export default class CustomerOrderService {

    static async getAllCustomerOrders() {
        return axios.get(orderRestUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getCompositionCustomerOrders() {
        return axios.get(orderRestUrl + '/composition', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getCountOffers(id) {
        return axios.get(orderRestUrl + "/count-offers/" + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async deleteOffers(id) {
        return axios.delete(orderRestUrl + '/offers/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getById(id) {
        return axios.get(orderRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getByIdWithComposition(id) {
        return axios.get(`${orderRestUrl}/${id}/with-composition`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    /** One retry after a fixed delay if the order card is not ready yet (404 or empty composition). */
    static async getByIdWithCompositionWithSingleRetry(
        id,
        {retryDelayMs = ORDER_WITH_COMPOSITION_RETRY_DELAY_MS} = {},
    ) {
        try {
            const response = await this.getByIdWithComposition(id);
            if (isOrderWithCompositionReady(response.data)) {
                return response;
            }
        } catch (error) {
            const status = error?.response?.status;
            if (status !== 404) {
                throw error;
            }
        }

        await delay(retryDelayMs);
        return this.getByIdWithComposition(id);
    }

    static async save(data) {
        return await axios.post(orderRestUrl, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async edit(id, data) {
        return await axios.put(`${orderRestUrl}/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return axios.delete(orderRestUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async sendToArchiveById(id) {
        return await axios.patch(orderRestUrl + '/' + id + '/set-to-archive',
            [], {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async confirmPerformerFromComposition(id) {
        return await axios.patch(
            `${orderRestUrl}/${id}/confirm-performer-from-composition`,
            [],
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
    }

    static async sendToArchive(data) {
        return await axios.patch(orderRestUrl + '/set-to-archive',
            JSON.stringify(data), {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }

    static async getOrdersArchive() {
        return axios.get(orderRestUrl + '/archive', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}